import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Options } from '@shared/models/options';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';
import { environment } from '@env/environment';


export enum CD_FILE_TARGET {
  PHOTO = 'photos',
  FILE = 'attachments',
  RAFORM = 'raForms',
}

@Injectable({
  providedIn: 'root'
})
export class ConcealedDamageApi extends ApiCommon {
  protected backend = environment.api.backend;

  getConcealedDamages(pageEvent, opt?: Options): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (opt?.q) {
      builder.q = opt.q;
    }

    if (opt?.query) {
      builder.query = opt.query;
    }

    if (opt?.startDate) {
      builder.startDate = opt.startDate;
    }
    if (opt?.endDate) {
      builder.endDate = opt.endDate;
    }
    if (opt?.chart) {
      return this.apiServer.concealedDamage.getChartConcealedDamages(builder.build());
    }

    return this.apiServer.concealedDamage.getConcealedDamages(builder.build());
  }

  getConcealedDamage(ticketNo): Observable<any> {
    return this.apiServer.concealedDamage.getConcealedDamage(ticketNo);
  }

  getCheckSerial(serialNo): Observable<any> {
    return this.apiServer.concealedDamage.getCheckSerial(serialNo);
  }

  createConcealedDamage(data): Observable<any> {
    return this.apiServer.concealedDamage.createConcealedDamage(data);
  }

  updateConcealedDamage(ticketNo, data): Observable<any> {
    return this.apiServer.concealedDamage.updateConcealedDamage(ticketNo, data);
  }

  deleteConcealedDamage(ticketNo): Observable<any> {
    return this.apiServer.concealedDamage.deleteConcealedDamage(ticketNo);
  }

  saveConcealedDamage(data, ticketNo?): Observable<any> {
    if (ticketNo) {
      return this.updateConcealedDamage(ticketNo, data);
    } else {
      return this.createConcealedDamage(data);
    }
  }

  updateComment(ticketNo, data): Observable<any> {
    return this.apiServer.concealedDamage.updateComment(ticketNo, data);
  }

  deleteFile(ticketNo, data): Observable<any> {
    return this.apiServer.concealedDamage.deleteFile(ticketNo, data);
  }

  fileUpload(ticketNo, targetType, formData): Observable<any> {
    return this.apiServer.concealedDamage.fileUpload(ticketNo, targetType, formData);
  }

  fileDownload(ticketNo, targetType): Observable<any> {
    return this.apiServer.concealedDamage.fileDownload(ticketNo, targetType);
  }

  syncRaRequestStatus(): Observable<any> {
    return this.apiServer.concealedDamage.syncRaRequestStatus();
  }

  fileUrl(file: any, disposition?): string {
    /*const { ticketNo } = ticketInfo;
    const { secret, key, _id } = attachment;*/
    const { _id } = file;
    let url = `${ this.backend }/image/concealed-damage/server-file/${ _id }?disposition=${ disposition }`;
    return url;
  }

  pdfUrl(ticketNo: any): string {
    let url = `${ this.backend }/concealed-damage/${ ticketNo }/report`;
    return url;
  }
}
